/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Measure_Price_CeilingInputs */

const en_measure_price_ceiling = /** @type {(inputs: Measure_Price_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`up to ${i?.amount} / request`)
};

const zh_hans1_measure_price_ceiling = /** @type {(inputs: Measure_Price_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每次请求最多 ${i?.amount}`)
};

const pt_br2_measure_price_ceiling = /** @type {(inputs: Measure_Price_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`até ${i?.amount} / requisição`)
};

const es_measure_price_ceiling = /** @type {(inputs: Measure_Price_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`hasta ${i?.amount} / solicitud`)
};

const fr_measure_price_ceiling = /** @type {(inputs: Measure_Price_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`jusqu’à ${i?.amount} / requête`)
};

const de_measure_price_ceiling = /** @type {(inputs: Measure_Price_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`bis zu ${i?.amount} / Anfrage`)
};

const ru_measure_price_ceiling = /** @type {(inputs: Measure_Price_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`до ${i?.amount} / запрос`)
};

const it_measure_price_ceiling = /** @type {(inputs: Measure_Price_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`fino a ${i?.amount} / richiesta`)
};

/**
* | output |
* | --- |
* | "up to {amount} / request" |
*
* @param {Measure_Price_CeilingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_price_ceiling = /** @type {((inputs: Measure_Price_CeilingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Price_CeilingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_price_ceiling(inputs)
	if (locale === "pt-BR") return pt_br2_measure_price_ceiling(inputs)
	if (locale === "es") return es_measure_price_ceiling(inputs)
	if (locale === "fr") return fr_measure_price_ceiling(inputs)
	if (locale === "de") return de_measure_price_ceiling(inputs)
	if (locale === "ru") return ru_measure_price_ceiling(inputs)
	if (locale === "it") return it_measure_price_ceiling(inputs)
	return en_measure_price_ceiling(inputs)
});